import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcLocationFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 10a8 8 0 1 1 16 0c0 2.453-1.069 4.852-2.345 6.855-1.284 2.015-2.827 3.706-3.884 4.761a2.48 2.48 0 0 1-3.54-.006c-1.055-1.061-2.599-2.762-3.883-4.778C5.07 14.828 4 12.433 4 10m8.002 2.049q1.033 0 1.765-.735.733-.735.733-1.768t-.735-1.764a2.41 2.41 0 0 0-1.767-.733q-1.033 0-1.765.735A2.41 2.41 0 0 0 9.5 9.55q0 1.032.735 1.765.736.733 1.767.733",
    clipRule: "evenodd"
  }));
}
var IcLocationFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLocationFill));

export { IcLocationFill as I };
